// extracted by mini-css-extract-plugin
export default {"productGrid":"A1-z","centerLink":"B1-z","productSection":"C1-z","item":"D1-z","ctaButton":"E1-z"};